/* ----------------------------------------------------Footer menu---------------------------------------- */
export const footerToggleHandler = () => {
    $('.footer-nav__title').on('click', function () {
		$('.footer-nav__item.active').not($(this).parent()).removeClass('active');
		$('.footer-nav__item ul').not($(this).siblings('ul')).slideUp(300);

		$(this).siblings('ul').slideToggle(300);
		$(this).parents('.footer-nav__item').toggleClass('active');
	});
};